import React from "react";
import { ViewComponent } from "./ViewComponent";
import { TransProps } from "@lingui/react";
import { typeData } from "components/UI/BarChart/BarChart";

// Constant
export enum STATISTIC_TYPES {
  SALES_AMOUNT = "sales-amount",
  CHECKS_COUNT = "checks-count",
  AVERAGE_CHECK = "average-check",
  REFUNDS_AMOUNT = "refunds-amount",
  REFUNDS_COUNT = "refunds-count",
  PAYMENT_METHODS = "payment-methods",
  PAYMENT_TYPES = "payment-types",
  DAILY_STATISTIC = "daily-statistic",
  EMPLOYEE_STATISTIC = "employee-statistic",
  PRODUCT_STATISTIC = "product-statistic",
}

const newShop: typeData = {
  labels: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10"],
  datasets: [
    {
      label: "Магазин1",
      data: [5, 2, 8, 3, 4, 2, 3, 9, 3],
    },
    {
      label: "Магазин2",
      data: [10, 20, 5, 8, 5, 6, 4, 5, 2, 5],
    },
    {
      label: "Магазин3",
      data: [8, 8, 6, 10, 9, 15, 5, 15, 8, 3],
    },
    {
      label: "Магазин4",
      data: [15, 12, 15, 13, 14, 17, 20, 19, 18],
    },
  ],
};

// Types
export type typeStatisticsDetailPage = {
  variant?: string;
  title: React.ReactElement<TransProps>;
  statisticType: STATISTIC_TYPES;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

// Component
export const StatisticsDetailPage: React.FC<typeStatisticsDetailPage> = ({
  variant,
  title,
  setSidebarOpen,
  statisticType,
}) => {
  return (
    <ViewComponent
      variant={variant}
      title={title}
      statisticType={statisticType}
      setSidebarOpen={setSidebarOpen}
      firstChartData={newShop}
    />
  );
};
